import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'
import {FormattedMessage} from 'react-intl'
import {Box, Image, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'
import {blogRoute} from '../../utills/url'

const FeaturedArticle = ({featuredArticle}) => {
    const {isFeatureMediaVideo, featuredMedia, id, publishDate, description, title, name, tags} =
        featuredArticle

    return (
        <>
            <Box as="section">
                <Box
                    margin={pxToRem(20)}
                    marginTop={0}
                    paddingBottom={pxToRem(20)}
                    borderBottom={'1px solid'}
                    borderColor={'cav_pdp_light_gray'}
                >
                    <Box maxWidth={pxToRem(750)} width={'100%'} margin={'0 auto'}>
                        {featuredMedia ? (
                            isFeatureMediaVideo ? (
                                <Box
                                    sx={{
                                        position: 'relative',
                                        paddingBottom: '56.25%',
                                        height: 0,
                                        overflow: 'hidden'
                                    }}
                                >
                                    <iframe
                                        src={featuredMedia}
                                        title={'item.title'}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%'
                                        }}
                                    ></iframe>
                                </Box>
                            ) : (
                                <Link
                                    to={blogRoute(`${id}.html`)}
                                    as={RouteLink}
                                    title={title}
                                    _hover={{textDecoration: 'none', color: 'cav_hover_brightred'}}
                                >
                                    <Image src={featuredMedia} alt={title} width={'100%'} />
                                    <Box
                                        as="h2"
                                        textTransform={'none'}
                                        fontSize={pxToRem(22)}
                                        fontFamily={fonts.primary}
                                        lineHeight={pxToRem(18)}
                                        letterSpacing={pxToRem(1)}
                                        color={'cav_light_black'}
                                        textAlign={'center'}
                                        margin={`${pxToRem(10)} 0`}
                                        fontWeight={700}
                                        _hover={{
                                            textDecoration: 'none',
                                            color: 'cav_hover_brightred'
                                        }}
                                        dangerouslySetInnerHTML={{__html: name}}
                                    ></Box>
                                </Link>
                            )
                        ) : null}

                        <Box
                            as="p"
                            textTransform={'none'}
                            fontSize={pxToRem(14)}
                            fontFamily={fonts.primary}
                            lineHeight={pxToRem(20)}
                            letterSpacing={pxToRem(1)}
                            color={'black'}
                            textAlign={'center'}
                            margin={`${pxToRem(10)} 0`}
                            fontWeight={400}
                        >
                            {publishDate}
                        </Box>
                        <Box textAlign={'center'}>
                            {tags.map((tag, index) => (
                                <Link
                                    key={tag.id}
                                    to={blogRoute(`${tag.id}`)}
                                    as={RouteLink}
                                    title={tag.displayName}
                                    fontSize={pxToRem(14)}
                                    lineHeight={pxToRem(20)}
                                    letterSpacing={pxToRem(1)}
                                    textAlign={'center'}
                                    color={'cav_hover_brightred'}
                                    fontFamily={fonts.primary}
                                    fontWeight={600}
                                    _hover={{textDecoration: 'none'}}
                                >
                                    {tag.displayName}
                                    {index < tags.length - 1 && ', '}
                                </Link>
                            ))}
                        </Box>
                    </Box>
                    <Box padding={`0 ${pxToRem(20)}`} textAlign={'center'}>
                        <Box
                            as="p"
                            textTransform={'none'}
                            fontSize={pxToRem(14)}
                            fontFamily={fonts.primary}
                            lineHeight={pxToRem(20)}
                            letterSpacing={pxToRem(1)}
                            color={'black'}
                            textAlign={'center'}
                            marginTop={pxToRem(20)}
                            marginBottom={pxToRem(20)}
                            fontWeight={400}
                            dangerouslySetInnerHTML={{__html: `${description} [...]`}}
                        ></Box>
                        <Link
                            to={blogRoute(`${id}.html`)}
                            as={RouteLink}
                            fontSize={pxToRem(14)}
                            lineHeight={pxToRem(18)}
                            letterSpacing={pxToRem(1)}
                            textAlign={'center'}
                            color={'white'}
                            fontFamily={fonts.primary}
                            marginBottom={0}
                            textTransform={'uppercase'}
                            whiteSpace={'nowrap'}
                            backgroundColor={'cav_hover_brightred'}
                            fontWeight={600}
                            padding={`${pxToRem(7)} ${pxToRem(28)}`}
                            borderWidth={pxToRem(1)}
                            borderColor={'cav_hover_brightred'}
                            borderRadius={0}
                            _hover={{
                                textDecoration: 'none',
                                color: 'cav_hover_brightred',
                                backgroundColor: 'white',
                                border: '1px solid cav_hover_brightred'
                            }}
                        >
                            <FormattedMessage
                                defaultMessage="Read more"
                                id="blog_landing.feature_article.label.read_more_label"
                            />
                        </Link>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

FeaturedArticle.propTypes = {
    featuredArticle: PropTypes.object
}
export default FeaturedArticle
